<template>
  <div>
    <ubi-panel class="mt-4">
      <h3>{{ $t('etablishmentSheet.title') }}</h3>
      <el-form ref="form" :model="localData" label-width="120px" v-loading="getLoadingEtablishment" :element-loading-text="$t('portals.list.chargementDonnees')">
<!--         Données générales-->
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title">
              <p class="subtitle">{{ $t('etablishmentSheet.subtitleDataGeneral') }}</p>
            </template>
            <!--            id Externe -->
            <el-form-item>
              <template>
                {{ $t('etablishmentSheet.idExternal') }}
                <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentIdExterne')" placement="right">
                  <em class="el-icon-question"></em>
                </el-tooltip>
              </template>
              <el-input v-model="localData.id_externe" :disabled="true"/>
            </el-form-item>
            <!--            Raison sociale -->
            <el-form-item>
              <template>
                {{$t('etablishmentSheet.companyName')}}
                <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentCompanyName')" placement="right">
                  <em class="el-icon-question"></em>
                </el-tooltip>
              </template>
              <el-input v-model="localData.raison_sociale"/>
            </el-form-item>
            <!--            nom commerce-->
            <el-form-item>
              <template>
                {{$t('etablishmentSheet.tradeName')}}
                <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentNomCommerce')" placement="right">
                  <em class="el-icon-question"></em>
                </el-tooltip>
              </template>
              <el-input v-model="localData.nom_commerce"/>
            </el-form-item>
            <!--            Long nom commerce-->
            <el-form-item>
              <template>
                {{$t('etablishmentSheet.longTradeName')}}
                <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentLongName')" placement="right">
                  <em class="el-icon-question"></em>
                </el-tooltip>
              </template>
              <el-input v-model="localData.long_name"/>
            </el-form-item>
            <el-row :gutter="24">
              <el-col :span="12">
                <!--            nom-->
                <el-form-item>
                  <template>
                    {{$t('etablishmentSheet.contactName')}}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentContactName')" placement="right">
                      <em class="el-icon-question mt-1"></em>
                    </el-tooltip>
                  </template>
                  <el-input v-model="localData.nom_contact_a_afficher"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--            prénom-->
                <el-form-item>
                  <template>
                    {{$t('etablishmentSheet.firstNameOfContact')}}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentContactFirstname')" placement="right">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </template>
                  <el-input v-model="localData.prenom_contact_a_afficher"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <!--            Téléphone-->
                <el-form-item>
                  <template>
                    {{$t('etablishmentSheet.phone')}}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentPhone')" placement="right">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </template>
                  <el-input v-model="localData.telephone_a_afficher"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--            Téléphone 2-->
                <el-form-item>
                  <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentPhone2')" placement="right">
                    <template>
                      {{$t('etablishmentSheet.phone2')}} <em class="el-icon-question"></em>
                    </template>
                  </el-tooltip>
                  <el-input v-model="localData.telephone_a_afficher_2"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--            Téléphone 3-->
                <el-form-item>
                  <template>
                    {{$t('etablishmentSheet.phone3')}}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentPhone3')" placement="right">
                      <em class="el-icon-question mt-1"></em>
                    </el-tooltip>
                  </template>
                  <el-input v-model="localData.telephone_a_afficher_3"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8">
                <!--            Téléphone mobile-->
                <el-form-item>
                  <template>
                    {{ $t('etablishmentSheet.mobile') }}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentMobile')" placement="right">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </template>
                  <el-input v-model="localData.telephone_mobile_a_afficher"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--            Mail-->
                <el-form-item>
                  <template>
                    {{ $t('etablishmentSheet.mail') }}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentMail')" placement="right">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </template>
                  <el-input v-model="localData.email_a_afficher"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--            Mail Admin-->
                <el-form-item>
                  <template>
                    {{ $t('etablishmentSheet.mailAdmin') }}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentMailAdmin')" placement="right">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </template>
                  <el-input v-model="localData.email_contact_admin"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <!--           Status-->
                <el-form-item>
                  <template>
                    {{ $t('etablishmentSheet.statusCompany') }}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentStatus')" placement="right">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </template>
                  <el-select v-model="localData.statut_pdv" clearable
                             :placeholder="$t('etablishmentSheet.placeholderStatusCompany')">
                    <el-option :label="$t('etablishmentSheet.open')" :value="$t('etablishmentSheet.open')"></el-option>
                    <el-option :label="$t('etablishmentSheet.underConstruction')"
                               :value="$t('etablishmentSheet.underConstruction')"></el-option>
                    <el-option :label="$t('etablishmentSheet.temporarilyClosed')"
                               :value="$t('etablishmentSheet.temporarilyClosed')"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--           SIRET -->
                <el-form-item>
                  <template>
                    {{ $t('etablishmentSheet.siret') }}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentSIRET')" placement="right">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </template>
                  <el-input v-model="localData.siret_entreprise"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <!--           SIRET -->
                <el-form-item>
                  <template>
                    {{ $t('etablishmentSheet.openingDate') }}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentOpeningDate')" placement="right">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </template>
                  <el-date-picker style="width: 490px" v-model="localData.opening_date" type="date"
                                  placeholder="Choississez un jour"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--           MEDIA STORE -->
                <el-form-item>
                  <template>
                    {{ $t('etablishmentSheet.mediaStoreGoogle') }}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentStoreCodeMedias')" placement="right">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </template>
                  <el-input v-model="localData.media_store_codes.GOOGLE_MAPS" :disabled="true"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--   Validation Données -->
          <el-collapse-item name="2">
            <template slot="title">
              <p class="subtitle">{{ $t('etablishmentSheet.subtitleValidationData') }}</p>
            </template>
            <el-row :gutter="24">
              <el-col :span="12">
                <!--           Validation mobile -->
                <el-form-item>
                  <template>
                    {{ $t('etablishmentSheet.validationMobile') }}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentValidationDataMobile')" placement="right">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </template>
                  <el-input v-model="localData.validation_mobile_phone">
                    <i slot="suffix" class="el-icon-phone"></i>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--           Validation mail -->
                <el-form-item>
                  <template>
                    {{ $t('etablishmentSheet.validationMail') }}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentValidationDataMail')" placement="right">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </template>
                  <el-input v-model="localData.validation_email" type="email">
                    <i slot="suffix" class="el-icon-message"></i>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--        Address-->
          <el-collapse-item name="3">
            <template slot="title">
              <p class="subtitle">{{ $t('etablishmentSheet.subtitleAdress') }}</p>
            </template>
            <!--           Adresse commerce -->
            <template>
              {{ $t('etablishmentSheet.businessAddress') }}
              <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentAdresseCommerce')" placement="right">
                <em class="el-icon-question"></em>
              </el-tooltip>
            </template>
            <el-form-item>
              <el-input v-model="localData.adresse_commerce"/>
            </el-form-item>
            <!--           Adresse 2 commerce -->
            <el-form-item>
              <template>
                {{ $t('etablishmentSheet.businessAddressComplement') }}
                <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentAdresseCommerce2')" placement="right">
                  <em class="el-icon-question"></em>
                </el-tooltip>
              </template>
              <el-input v-model="localData.adresse_2_commerce"/>
            </el-form-item>
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item :label="$t('etablishmentSheet.postalCodeCompany')">
                  <el-autocomplete
                      v-model="localData.code_postal_commerce"
                      :fetch-suggestions="searchVilleByCodePostal"
                      @select="selectVilleByCodePostal">
                  </el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('etablishmentSheet.cityCompany')">
                  <el-input v-model="localData.ville_commerce" :disabled="true"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('etablishmentSheet.country')">
                  <el-input v-model="localData.country_code"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <!--           Latitude -->
                <el-form-item>
                  <template>
                    {{ $t('etablishmentSheet.latitude') }}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentLatitude')" placement="right">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </template>
                  <el-input v-model="localData.latitude"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--           Longitude -->
                <el-form-item>
                  <template>
                    {{ $t('etablishmentSheet.longitude') }}
                    <el-tooltip effect="dark" :content="$t('etablishmentSheet.tooltipContentLongitude')" placement="right">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </template>
                  <el-input v-model="localData.longitude"/>
                </el-form-item>
              </el-col>
              <el-col v-if="this.localData.latitude !== '' && this.localData.longitude !== ''">
                <template>
                  <l-map style="height: 300px;" :zoom="15" :center="[this.localData.latitude, this.localData.longitude]" v-if="activeNames.includes('3')">
                    <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"></l-tile-layer>
                    <l-marker :lat-lng="[this.localData.latitude, this.localData.longitude]"></l-marker>
                  </l-map>
                </template>
              </el-col>
            </el-row>
          </el-collapse-item>

<!--          Days -->
          <el-collapse-item name="4">
            <template slot="title">
              <p class="subtitle">{{ $t('etablishmentSheet.subtitleSchedules') }}</p>
            </template>
            <el-table
              :data="days"
              style="width: 100%"
            >
              <el-table-column
               fixed
               prop="day"
               :label="$t('etablishmentSheet.days')"
               width="180"
              >
              </el-table-column>
              <el-table-column
                  :label="$t('etablishmentSheet.status')"
                  width="180">
                <template v-slot="{ row: day }">
                  <el-switch
                      @change="handleSwitch(day)"
                      v-model="day.open"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :active-text="$t('etablishmentSheet.open')"
                      :inactive-text="$t('etablishmentSheet.close')"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column
                  props="fullHours"
                  :label="$t('etablishmentSheet.fullHours')"
                  width="180">
                <template v-slot="{ row: day }">
                  <el-checkbox v-model="day.fullHours" @change="addAutomaticDate(day)" v-if="day.open"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column width="350">
                <template v-slot="{ row: day }">
                  <el-time-select
                      v-if="day.open"
                      placeholder="Horaire de début"
                      v-model="day.ouv1"
                      :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '23:59'
                }">
                  </el-time-select>
                  <el-time-select
                      v-if="day.open"
                      placeholder="Horaire de fin"
                      v-model="day.fer1"
                      :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '23:59',
                  minTime: day.ouv1
                }">
                  </el-time-select>
                </template>
              </el-table-column>
              <el-table-column width="350px">
                <template v-slot="{ row: day }">
                  <el-time-select
                      v-if="day.open && day.showTimes2 && !day.fullHours"
                      placeholder="Horaire de début"
                      v-model="day.ouv2"
                      :picker-options="{
                   start: '06:00',
                  step: '00:15',
                  end: '23:59'
                }">
                  </el-time-select>
                  <el-time-select
                      v-if="day.open && day.showTimes2 && !day.fullHours"
                      placeholder="Horaire de fin"
                      v-model="day.fer2"
                      :picker-options="{
                    start: '06:00',
                  step: '00:15',
                  end: '23:59',
                  minTime: day.ouv2
                }">
                  </el-time-select>
                </template>
              </el-table-column>
              <el-table-column fixed="right" :label="$t('etablishmentSheet.actions')" width="180px">
                <template v-slot="{row: day}">
                  <el-tooltip effect="dark" :content="$t('etablishmentSheet.duplicate')" placement="top-start">
                    <el-button
                        type="primary"
                        @click="duplicatedLine(day)"
                        :disabled="!day.duplicate"
                        v-if="day.id !== 1"
                    >
                      <i class="el-icon-document-copy"></i>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('etablishmentSheet.addSchedule')" placement="top-start">
                    <el-button
                        type="primary"
                        @click="addSchedule(day)"
                        :disabled="!day.open || day.fullHours"
                    >
                      <i class="el-icon-circle-plus-outline"></i>
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>

          <!--              Exceptional days-->
          <el-collapse-item name="5">
            <template slot="title">
              <p class="subtitle">{{ $t('etablishmentSheet.subtitleExceptionalSchedules') }}</p>
            </template>
            <template>
              <div class="container-several-days" v-if="mustAddExceptionalDays">
                <el-form label-width="120px" class="form-several-days">
                  <el-form-item :label="$t('etablishmentSheet.chooseAddDay')">
                    <el-date-picker
                        v-model="exceptionalDay.dates"
                        type="datetimerange"
                        range-separator="à"
                        start-placeholder="Date de début"
                        end-placeholder="Date de fin">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-switch
                        v-model="exceptionalDay.open"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        :active-text="$t('etablishmentSheet.open')"
                        :inactive-text="$t('etablishmentSheet.close')"
                    >
                    </el-switch>
                  </el-form-item>
                  <el-form-item v-if="exceptionalDay.open">
                    <el-time-select
                        placeholder="Horaire de début"
                        v-model="exceptionalDay.ouv1"
                        :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '23:59'
                }">
                    </el-time-select>
                    <el-time-select
                        placeholder="Horaire de fin"
                        v-model="exceptionalDay.fer1"
                        :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '23:59',
                  minTime: exceptionalDay.ouv1
                }">
                    </el-time-select>
                  </el-form-item>
                  <el-form-item v-if="exceptionalDay.open && exceptionalDay.showTimes2">
                    <el-time-select
                        placeholder="Horaire de début"
                        v-model="exceptionalDay.ouv2"
                        :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '23:59'
                }">
                    </el-time-select>
                    <el-time-select
                        placeholder="Horaire de fin"
                        v-model="exceptionalDay.fer2"
                        :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '23:59',
                  minTime: exceptionalDay.ouv2
                }">
                    </el-time-select>
                  </el-form-item>
                  <el-button type="primary" v-if="!exceptionalDay.showTimes2" style="width: 100%; height: 100%;"
                             class="mt-4 mb-4" @click="addExceptionalDays">{{ $t('etablishmentSheet.addSchedule') }}
                  </el-button>
                  <el-row type="flex" justify="end">
                    <el-col :span="5">
                      <el-button @click="cancelExceptionalDays">{{ $t('etablishmentSheet.cancel') }}</el-button>
                    </el-col>
                    <el-col :span="4">
                      <el-button type="primary" @click="createExceptionalDays">{{
                          $t('etablishmentSheet.create')
                        }}
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </template>
            <!--            exceptionnal hours-->
            <el-table
                v-if="exceptionalDays.length > 0"
                :data="exceptionalDays"
                style="width: 100%">
              <el-table-column
                  fixed
                  :label="$t('etablishmentSheet.date')"
                  width="250">
                <template v-slot="{ row: schedule}">
                  <el-date-picker
                      v-model="schedule.date"
                      type="date"
                      placeholder="Choississez un jour">
                  </el-date-picker>
                </template>
              </el-table-column>
              <el-table-column
                  :label="$t('etablishmentSheet.status')"
                  width="180">
                <template v-slot="{ row: schedule }">
                  <el-switch
                      @change="handleSwitch(schedule)"
                      v-model="schedule.open"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :active-text="$t('etablishmentSheet.open')"
                      :inactive-text="$t('etablishmentSheet.close')"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column
                  props="fullHours"
                  :label="$t('etablishmentSheet.fullHours')"
                  width="180">
                <template v-slot="{ row: schedule }">
                  <el-checkbox v-model="schedule.fullHours" @change="addAutomaticDate(schedule)"
                               v-if="schedule.open"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column width="350px">
                <template v-slot="{ row: schedule }">
                  <el-time-select
                      v-if="schedule.open"
                      placeholder="Horaire de début"
                      v-model="schedule.ouv1"
                      :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '23:59'
                }">
                  </el-time-select>
                  <el-time-select
                      v-if="schedule.open"
                      placeholder="Horaire de fin"
                      v-model="schedule.fer1"
                      :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '23:59',
                  minTime: schedule.ouv1
                }">
                  </el-time-select>
                </template>
              </el-table-column>
              <el-table-column width="350px">
                <template v-slot="{ row: schedule }">
                  <el-time-select
                      v-if="schedule.open && schedule.showTimes2 && !schedule.fullHours"
                      placeholder="Horaire de début"
                      v-model="schedule.ouv2"
                      :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '23:59'
                }">
                  </el-time-select>
                  <el-time-select
                      v-if="schedule.open && schedule.showTimes2 && !schedule.fullHours"
                      placeholder="Horaire de fin"
                      v-model="schedule.fer2"
                      :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '23:59',
                  minTime: schedule.ouv2
                }">
                  </el-time-select>
                </template>
              </el-table-column>
              <el-table-column fixed="right" :label="$t('etablishmentSheet.actions')" width="180px">
                <template v-slot="{row: schedule}">
                  <el-tooltip effect="dark" :content="$t('etablishmentSheet.addSchedule')" placement="top-start">
                    <el-button
                        type="primary"
                        @click="addSchedule(schedule)"
                        :disabled="!schedule.open || schedule.fullHours"
                    >
                      <i class="el-icon-circle-plus-outline"></i>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('etablishmentSheet.delete')" placement="top-start">
                    <el-button
                        type="primary"
                        @click="deletedLine(schedule)"
                    >
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-button type="primary" style="width: 100%; height: 100%;" @click="addNewExceptionalDay">
                  {{ $t('etablishmentSheet.chooseAddDay') }}
                </el-button>
              </el-col>
              <el-col :span="12">
                <el-button type="primary" style="width: 100%; height: 100%;" @click="addSeveralExceptionalDays">
                  {{ $t('etablishmentSheet.chooseSeveralDays') }}
                </el-button>
              </el-col>
            </el-row>
          </el-collapse-item>
<!--          photos -->
          <el-collapse-item name="6">
            <template slot="title">
              <p class="subtitle">{{ $t('etablishmentSheet.subtitlePhotos') }}</p>
            </template>
            <div class="container-photos mb-4" v-loading="getLoadingPhotos">
<!--              LOGO -->
              <div class="item-photos">
                <div class="header-photos">
                  <h2>{{ $t('etablishmentSheet.logo') }}</h2>
                  <p>{{ $t('etablishmentSheet.minSize') }}</p>
                  <p>{{ $t('etablishmentSheet.maxSize') }}</p>
                  <p>{{ $t('etablishmentSheet.weightBetween') }}</p>
                </div>
                <div class="body-photos">
                  <uploadDBKS sectionType="logo"/>
                </div>
              </div>
<!--              PROFILE-->
              <div class="item-photos">
                <div class="header-photos">
                  <h2>{{ $t('etablishmentSheet.profile') }}</h2>
                  <p>{{ $t('etablishmentSheet.minSize') }}</p>
                  <p>{{ $t('etablishmentSheet.maxSize') }}</p>
                  <p>{{ $t('etablishmentSheet.weightBetween') }}</p>
                </div>
                <div class="body-photos">
                  <uploadDBKS sectionType="profile"/>
                </div>
              </div>
<!--              COVER-->
              <div class="item-photos">
                <div class="header-photos">
                  <h2>{{ $t('etablishmentSheet.cover') }}</h2>
                  <p>{{ $t('etablishmentSheet.minSize') }}</p>
                  <p>{{ $t('etablishmentSheet.maxSize') }}</p>
                  <p>{{ $t('etablishmentSheet.weightBetween') }}</p>
                </div>
                <div class="body-photos">
                  <UploadDBKS sectionType="cover" />
                </div>
              </div>
            </div>
            <div>
              <!--              GALLERY-->
              <div class="item-photos-gallery">
                <div class="header-photos">
                  <h2>{{ $t('etablishmentSheet.gallery') }}</h2>
                  <p>{{ $t('etablishmentSheet.weightBetween') }}</p>
                </div>
                <div class="body-photos">
                  <UploadDBKS sectionType="gallery" />
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="7">
            <template slot="title">
              <p class="subtitle">{{ $t('etablishmentSheet.subtitleVideos') }}</p>
            </template>
            <BoxInfos v-if="showBoxInfos" :has-icon-info="false" :has-icon-close="false">
              <p style="font-size: 18px;">{{ $t('etablishmentSheet.contentVideo')}}</p>
              <p style="font-size: 16px;"><strong>{{ $t('etablishmentSheet.conditionVideo')}}</strong></p>
              <div style="color:red;">{{ $t('etablishmentSheet.warningDiffusion')}}</div>
              <ul style="margin-left: 20px">
                <li>{{ $t('etablishmentSheet.exampleVideo')}}</li>
                <li>{{ $t('etablishmentSheet.minWeightVideo')}}</li>
                <li>{{ $t('etablishmentSheet.timeMaxVideo')}}</li>
                <li>{{ $t('etablishmentSheet.resolutionVideo')}}</li>
              </ul>
            </BoxInfos>
            <el-row v-for="(url, index) in videos" :key="index">
               <el-col :span="21">
                 <el-input
                     v-model="videos[index]"
                     :placeholder="$t('etablishmentSheet.addUrlVideo')"
                     @change="updateVideo(index)"
                 ></el-input>
               </el-col>
              <el-col :span="2" class="mb-3 ml-2">
                <el-button type="danger" @click="deletedVideo(index)">
                  <em class="el-icon-delete"></em>
                </el-button>
              </el-col>
            </el-row>
            <el-button type="primary" @click="openFormVideo" :loading="false" style="width: 100%; height: 100%;">{{$t('etablishmentSheet.addVideo')}}</el-button>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </ubi-panel>
    <el-row type="flex" justify="end" class="mb-5">
      <el-col :span="4" style="margin-right:5px">
        <el-button type="success" :loading="false" @click="saveUploadPhotos">{{ $t('etablishmentSheet.savePictures') }}
        </el-button>
      </el-col>
      <el-col :span="3" style="margin-right: 65px">
        <el-button type="success" :loading="false" @click="saveEtablishmentSheet">{{ $t('etablishmentSheet.save') }}
        </el-button>
      </el-col>
      <el-col :span="2">
        <el-button :loading="false" @click="cancelEtablishmentSheet">{{ $t('etablishmentSheet.cancel') }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import UbiPanel from '@/components/Panel.vue'
import { LMap, LMarker, LTileLayer } from 'vue2-leaflet'
import { getFormatSFC } from '@/helpers/functions/formatSfcHoraires'
import UploadDBKS from '@/pages/etablishment/uploadDBKS.vue'
import BoxInfos from '@/components/ui/BoxInfos.vue'
import {mapGetters} from "vuex";

export default {
  name: 'EtablishmentSheet',
  components: {
    BoxInfos,
    UploadDBKS,
    UbiPanel,
    LMap,
    LTileLayer,
    LMarker
  },
  data () {
    return {
      activeNames: ['1'],
      days: [
        {
          id: 1,
          day: 'Lundi',
          open: false,
          duplicate: false,
          fullHours: false,
          ouv1: '',
          fer1: '',
          showTimes2: false,
          ouv2: '',
          fer2: ''
        },
        {
          id: 2,
          day: 'Mardi',
          open: false,
          duplicate: false,
          fullHours: false,
          ouv1: '',
          fer1: '',
          showTimes2: false,
          ouv2: '',
          fer2: ''
        },
        {
          id: 3,
          day: 'Mercredi',
          open: false,
          duplicate: false,
          fullHours: false,
          ouv1: '',
          fer1: '',
          showTimes2: false,
          ouv2: '',
          fer2: ''
        },
        {
          id: 4,
          day: 'Jeudi',
          open: false,
          duplicate: false,
          fullHours: false,
          ouv1: '',
          fer1: '',
          showTimes2: false,
          ouv2: '',
          fer2: ''
        },
        {
          id: 5,
          day: 'Vendredi',
          open: false,
          duplicate: false,
          fullHours: false,
          ouv1: '',
          fer1: '',
          showTimes2: false,
          ouv2: '',
          fer2: ''
        },
        {
          id: 6,
          day: 'Samedi',
          open: false,
          duplicate: false,
          fullHours: false,
          ouv1: '',
          fer1: '',
          showTimes2: false,
          ouv2: '',
          fer2: ''
        },
        {
          id: 7,
          day: 'Dimanche',
          open: false,
          duplicate: false,
          fullHours: false,
          ouv1: '',
          fer1: '',
          showTimes2: false,
          ouv2: '',
          fer2: ''
        }
      ],
      exceptionalDays: [],
      mustAddExceptionalDays: false,
      exceptionalDay: {
        dates: '',
        open: false,
        duplicate: false,
        fullHours: false,
        ouv1: '',
        fer1: '',
        showTimes2: false,
        ouv2: '',
        fer2: ''
      },
      form: {
        name: '',
        logo: null,
        cover: null,
        profile: null,
        gallery: []
      },
      showBoxInfos: true,
      showFormVideo: false,
      videos: []
    }
  },
  computed: {
    ...mapGetters(['getSitimmoUser']),
    localData () {
      return this.$store.getters['etablishmentSheet/getEtablishmentSheet']
    },
    getLoadingEtablishment () {
      return this.$store.getters['etablishmentSheet/getLoadingEtablishment']
    },
    getLoadingPhotos () {
      return this.$store.getters['etablishmentSheet/getLoadingPhotos']
    },
    initialVideos () {
      return this.$store.getters['etablishmentSheet/getVideos']
    }
  },
  watch: {
    initialVideos (newValue) {
      this.videos = [...newValue]
    },
    localData: {
      immediate: true,
      handler (newEtablishment) {
        this.updateDays(newEtablishment)
        this.updateExceptionalDays(newEtablishment)
      }
    }
  },
  methods: {
    handleSwitch (item) {
      const nextIndexItem = this.days.findIndex(day => day.id === item.id + 1)
      if (nextIndexItem !== -1) {
        this.days[nextIndexItem].duplicate = !this.days[nextIndexItem].duplicate
      }
      item.fullHours = false
      item.showTimes2 = false
      item.ouv1 = ''
      item.fer1 = ''
      item.ouv2 = ''
      item.fer2 = ''
      item.formatData = ''
    },
    addAutomaticDate (item) {
      if (item.fullHours) {
        item.ouv1 = '00:00'
        item.fer1 = '23:59'
      } else {
        item.ouv1 = ''
        item.fer1 = ''
      }
    },
    duplicatedLine (item) {
      const previousIndexItem = this.days.findIndex(day => day.id === item.id - 1)
      if (previousIndexItem !== -1) {
        const previousSchedule = this.days[previousIndexItem]
        const propertiesToCopy = ['open', 'fullHours', 'ouv1', 'fer1', 'showTimes2', 'ouv2', 'fer2']
        propertiesToCopy.forEach(prop => {
          if (prop in previousSchedule) {
            item[prop] = previousSchedule[prop]
          }
        })
      }
      const nextIndexItem = this.days.findIndex(day => day.id === item.id + 1)
      if (nextIndexItem !== -1) {
        this.days[nextIndexItem].duplicate = !this.days[nextIndexItem].duplicate
      }
    },
    addSchedule (item) {
      item.showTimes2 = !item.showTimes2
    },
    addExceptionalDays () {
      this.exceptionalDay.showTimes2 = true
    },
    cancelExceptionalDays () {
      this.exceptionalDay.showTimes2 = false
      this.exceptionalDay.open = false
      this.mustAddExceptionalDays = false
      this.exceptionalDay = {
        date: '',
        open: false,
        duplicate: false,
        fullHours: false,
        ouv1: '',
        fer1: '',
        showTimes2: false,
        ouv2: '',
        fer2: ''
      }
    },
    createExceptionalDays () {
      const start = new Date(this.exceptionalDay.dates[0])
      const end = new Date(this.exceptionalDay.dates[1])
      const datesArray = []

      let newStart = start
      while (newStart <= end) {
        datesArray.push(new Date(newStart))
        newStart = start.setDate(start.getDate() + 1)
      }
      datesArray.forEach((date) => {
        this.exceptionalDays.push({
          id: this.exceptionalDays.length,
          date: date,
          open: this.exceptionalDay.open,
          duplicate: this.exceptionalDay.duplicate,
          fullHours: this.exceptionalDay.fullHours,
          ouv1: this.exceptionalDay.ouv1,
          fer1: this.exceptionalDay.fer1,
          showTimes2: this.exceptionalDay.showTimes2,
          ouv2: this.exceptionalDay.ouv2,
          fer2: this.exceptionalDay.fer2
        })
      })
      this.exceptionalDay.showTimes2 = false
      this.mustAddExceptionalDays = false
    },
    deletedLine (schedule) {
      this.exceptionalDays = this.exceptionalDays.filter((item) => item.id !== schedule.id)
    },
    addNewExceptionalDay () {
      this.exceptionalDays.push({
        id: this.exceptionalDays.length,
        date: this.exceptionalDays.date,
        open: false,
        duplicate: false,
        fullHours: false,
        ouv1: '',
        fer1: '',
        showTimes2: false,
        ouv2: '',
        fer2: ''
      })
    },
    addSeveralExceptionalDays () {
      this.mustAddExceptionalDays = true
    },
    searchVilleByCodePostal (queryString, cb) {
      this.$store.dispatch('etablishmentSheet/searchByPostalCode', { queryString: queryString, pays: this.getSitimmoUser.pays })
      const results = this.$store.getters['etablishmentSheet/getCodePostalVille']
      const tab = Object.values(results)
      cb(tab)
    },
    selectVilleByCodePostal (item) {
      this.localData.code_postal_commerce = item.code_postal
      this.localData.ville_commerce = item.ville
    },
    saveUploadPhotos () {
      this.$confirm(this.$t('etablishmentSheet.saveConfirmationPictures'))
        .then(_ => {
          this.$store.dispatch('etablishmentSheet/uploadPhotosDBKS')
        })
        .catch(_ => {
          this.$message({ type: 'warning', message: this.$t('etablishmentSheet.errorSavePictures') })
        })
    },
    saveEtablishmentSheet () {
      this.days.forEach((day) => {
        const dayKey = day.day.toLowerCase()
        this.localData[`sfc_horaire_${dayKey}_ouv_1`] = day.ouv1
        this.localData[`sfc_horaire_${dayKey}_fer_1`] = day.fer1
        this.localData[`sfc_horaire_${dayKey}_ouv_2`] = day.ouv2
        this.localData[`sfc_horaire_${dayKey}_fer_2`] = day.fer2
      })
      // 18/11/2024:00h00:23h59;
      this.localData.sfc_horaires_exceptionnels = getFormatSFC(this.exceptionalDays)
      this.$store.commit('etablishmentSheet/setVideos', this.videos)
      this.$confirm(this.$t('etablishmentSheet.saveConfirmation'))
        .then(_ => {
          this.$store.dispatch('etablishmentSheet/updateEtablishment')
        })
        .catch(_ => {
          this.$message({ type: 'warning', message: this.$t('etablishmentSheet.errorSave') })
        })
    },
    cancelEtablishmentSheet () {
      this.$confirm(this.$t('etablishmentSheet.cancelConfirmation'))
        .then(_ => {
          this.$store.dispatch('etablishmentSheet/loadEtablishmentSheet')
        })
        .catch(_ => {
        })
    },
    openFormVideo () {
      this.showFormVideo = true
      this.videos.push('')
    },
    deletedVideo (index) {
      this.videos.splice(index, 1)
      console.log(`URL supprimée : ${index}`)
    },
    updateVideo (index) {
      console.log(`URL mise à jour : ${this.videos[index]}`)
    },
    updateDays (etablishment) {
      this.days.forEach((item) => {
        const itemDay = item.day.toLowerCase()
        item.ouv1 = etablishment[`sfc_horaire_${itemDay}_ouv_1`]
        item.fer1 = etablishment[`sfc_horaire_${itemDay}_fer_1`]
        item.ouv2 = etablishment[`sfc_horaire_${itemDay}_ouv_2`]
        item.fer2 = etablishment[`sfc_horaire_${itemDay}_fer_2`]
        item.open = (etablishment[`sfc_horaire_${itemDay}_ouv_1`] !== '')
        item.showTimes2 = (etablishment[`sfc_horaire_${itemDay}_ouv_2`] !== '')
        item.fullHours = (etablishment[`sfc_horaire_${itemDay}_ouv_1`] === '00h00' && etablishment[`sfc_horaire_${itemDay}_fer_1`] === '23h59' && etablishment[`sfc_horaire_${itemDay}_ouv_2`] === '')
      })
    },
    updateExceptionalDays (etablishment) {
      if (this.localData.sfc_horaires_exceptionnels !== '') {
        this.exceptionalDays = []
        const exceptionalDays = etablishment.sfc_horaires_exceptionnels.split(';')
        exceptionalDays.forEach((exceptionalDay, index) => {
          if (exceptionalDay !== '') {
            const [datePart, ...hoursParts] = exceptionalDay.split(':')
            const formatDate = datePart.split('/').reverse().join('-')
            const model = {
              id: this.exceptionalDays.length,
              date: '',
              open: false,
              duplicate: false,
              fullHours: false,
              ouv1: '',
              fer1: '',
              showTimes2: false,
              ouv2: '',
              fer2: ''
            }

            model.date = datePart
            if (datePart) {
              model.open = true
              model.date = new Date(formatDate)

              const formatHour = (hour) => {
                if (!hour) return ''
                const [h, m] = hour.split('h')
                const formattedHour = h.padStart(2, '0')
                const formattedMinutes = m ? m.padStart(2, '0') : '00'
                return `${formattedHour}:${formattedMinutes}`
              }

              if (hoursParts.length >= 2) {
                const hours = hoursParts.map(formatHour)

                if (hours[0] === '00:00' && hours[1] === '23:59') {
                  model.fullHours = true
                  model.ouv1 = '00:00'
                  model.fer1 = '23:59'
                } else if (hours.length > 2) {
                  model.duplicate = true
                  model.showTimes2 = true
                  model.ouv1 = hours[0]
                  model.fer1 = hours[1]
                  model.ouv2 = hours[2]
                  model.fer2 = hours[3] || ''
                } else {
                  model.ouv1 = hours[0]
                  model.fer1 = hours[1]
                }
              }
            }
            this.exceptionalDays.push(model)
          }
        })
      }
    }
  },
  created () {
    this.videos = [...this.initialVideos]
  },
  mounted () {
    this.$store.dispatch('etablishmentSheet/loadEtablishmentSheet')
    this.$store.dispatch('etablishmentSheet/loadListPhotosDBKS')
  }
}
</script>
<style lang="scss" scoped>
.subtitle {
  margin-top: 15px;
  font-size: 20px;
  font-weight: 600;
  color: #1e4a56;
  font-family: "Dosis", Helvetica, Arial, sans-serif;
}

.info-zone-chalandise {
  font-size: 15px;
  font-weight: 500;
}

.target-link {
  text-decoration: none;
  font-weight: bold;
  color: #00a4bd;
  cursor: pointer;
}

.time-custom {
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: start;
  gap: 10px;
}

.copy-line {
  cursor: pointer;
}

/*GALERIES PHOTOS*/
.container-photos {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;

  .item-photos {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 20px;

    .header-photos {
      text-align: center;
      font-weight: bold;
      font-size: 20px;

      h2 {
        font-weight: 600;
      }

      p {
        font-size: 12px;
        margin: 0;
      }
    }

    .upload-btn {
      display: flex;
      justify-content: center;
      margin-top: 10px;
    }

    .body-photos {
      display: flex;
      justify-content: center;
      margin-top: 25px;
    }
  }
}

.container-several-days {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 10px;

  .form-several-days {
    border: 1px solid #cfd3d7;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
    width: 50%;
    padding: 10px;
  }
}
</style>
